module.exports = __webpack_public_path__ + "ff45fc19cc03f481ca46a0e6e773814e.MP3";